import { Routes } from '@angular/router';
import { OperatingCostsComponent } from '../../../pages/finances/operating-costs/operating-costs.component';
import { ShiveRoutes } from '../segments/route-segments';
import { UrlSegmentDelimiter } from '../../constants-repository/app-style.constants';
import { InvoiceThemeShellComponent } from '../../../features/invoice-theme/invoice-theme-shell/invoice-theme-shell.component';
import {
  invoiceContentAreasResolver,
  invoicePositionsResolver,
  invoiceThemePropsResolver,
} from '../../resolver/invoice/invoice-input.resolver';
import { InvoiceListComponent } from '../../../pages/finances/invoices/invoice-list/invoice-list.component';
import { invoiceDataResolver } from '../../resolver/invoice/invoice-data.resolver';
import { confirmCreateInvoiceGuard } from '../../guards/confirm-create-invoice.guard';
import { InvoiceCreateEditComponent } from '../../../pages/finances/invoices/invoice-creation-editing/invoice-create-edit.component';

export const FinanceRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ShiveRoutes.FinancesInvoicesOverview,
  },
  {
    path: ShiveRoutes.Invoices + UrlSegmentDelimiter + ShiveRoutes.Overview,
    component: InvoiceListComponent,
  },
  {
    path: ShiveRoutes.Invoices + UrlSegmentDelimiter + ShiveRoutes.Create,
    component: InvoiceCreateEditComponent,
    canActivate: [confirmCreateInvoiceGuard],
    resolve: {
      mode: () => 'create',
      invoice: invoiceDataResolver, // Load template if query param is set.
    },
  },
  {
    path: `${ShiveRoutes.Invoices + UrlSegmentDelimiter + ShiveRoutes.Detail + UrlSegmentDelimiter}:id`,
    component: InvoiceCreateEditComponent,
    resolve: {
      mode: () => 'edit',
      invoice: invoiceDataResolver,
    },
  },
  {
    path: `${ShiveRoutes.PrintInvoice + UrlSegmentDelimiter}:id`, // Todo: Load from config since path is hard-coded in backend.
    component: InvoiceThemeShellComponent,
    resolve: {
      themeProps: invoiceThemePropsResolver,
      mode: () => 'print',
      contentAreas: invoiceContentAreasResolver,
      invoicePositions: invoicePositionsResolver,
    },
  },
  {
    path: ShiveRoutes.OperatingExpenses,
    component: OperatingCostsComponent,
  },
];
